import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppEnvironment } from 'sham-components/services';

@Component({
  selector: 'sham-wide-banner',
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="content-section mx-auto w-full">
      <a
        [routerLink]="navigationEnabled() && link() ? ['/categories', link()] : null"
        class="group block w-full"
      >
        <div class="w-full h-[118px] overflow-hidden rounded-xl bg-[#E8E7E8]">
          <img
            [src]="imageUrl()"
            [alt]="imageAlt()"
            loading="lazy"
            class="block w-full h-full object-contain object-center rounded-xl transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.025] group-hover:brightness-[1.02]"
          />
        </div>
      </a>
    </div>
  `,
})
export class WideBanner {
  private readonly appEnv = inject(AppEnvironment);
  readonly image = input<string | null>(null);
  readonly imageAlt = input('');
  readonly link = input<string | null>(null);
  readonly navigationEnabled = input(true);

  imageUrl(): string {
    const path = this.image();
    if (!path) return '';
    return path.startsWith('http') ? path : `${this.appEnv.BASE_URL()}${path}`;
  }
}
